/**
 * Formateo de importes en la moneda elegida en el selector de la cabecera.
 *
 * Los informes llegan del backend ya convertidos: aquí no se convierte nada,
 * solo se formatea.
 */

/* Los símbolos los pone esta tabla y no Intl, para que salgan iguales que en las
   cabeceras de los Excel (Utils/MonedasZona.cs). Peso y dólar son los dos "$" y
   entre ellos hay un factor 20: van con prefijo para no confundirlos. */
const SIMBOLOS = { EUR: "€", USD: "US$", MXN: "MX$" };

/* Misma tabla que MonedasZona.DeZona en el backend. Solo se usa para saber si una
   fila viene de otra moneda y avisar de que se ha convertido. */
const MONEDA_POR_ZONA = { 1: "EUR", 2: "MXN", 3: "EUR" };

const MONEDA_POR_DEFECTO = "EUR";

/* Un único locale para las tres: los separadores deben ser los mismos que en el
   resto de la aplicación, que formatea todo en es-ES. */
const LOCALE = "es-ES";

export const simboloMoneda = (moneda) => SIMBOLOS[moneda] ?? SIMBOLOS.EUR;

/* Símbolo de la moneda que hay elegida ahora mismo.
   Los informes personalizados formatean desde funciones sueltas (`formatNew.js`),
   que no son componentes y no pueden leer el contexto. Como la moneda es una sola
   para toda la aplicación, el proveedor la deja aquí y esas funciones la consultan.
   No es estado compartido de verdad: en el navegador hay un usuario y una moneda. */
let simboloActivo = SIMBOLOS.EUR;

export const setSimboloActivo = (simbolo) => {
    simboloActivo = simbolo || SIMBOLOS.EUR;
};

export const getSimboloActivo = () => simboloActivo;

export const monedaDeZona = (codZona) =>
    MONEDA_POR_ZONA[Number(codZona)] ?? MONEDA_POR_DEFECTO;

/** Formateador reutilizable; crear uno por render es caro en tablas largas. */
export const formateadorMoneda = (moneda, opciones = {}) => {
    const numero = new Intl.NumberFormat(LOCALE, {
        maximumFractionDigits: 0,
        ...opciones,
    });

    const simbolo = simboloMoneda(moneda);

    return {
        format: (valor) => {
            const num = Number(valor);
            if (!Number.isFinite(num)) return "—";
            return `${numero.format(num)} ${simbolo}`;
        },
    };
};

/** True si alguna fila procede de una zona con moneda distinta a la mostrada. */
export const hayImportesConvertidos = (filas, moneda) =>
    (Array.isArray(filas) ? filas : []).some(
        (fila) => monedaDeZona(fila?.codZona) !== moneda
    );
